import React from 'react';

function TermsOfService() {
  return (
    <div className="container" style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }} data-testid="terms-of-service">
      <h1 className="heading-2" style={{ marginBottom: '32px' }}>Terms of Service</h1>
      <p className="body-medium" style={{ color: 'var(--text-secondary)', marginBottom: '32px' }}>
        Last updated: February 2, 2025
      </p>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>1. Acceptance of Terms</h2>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)' }}>
          By accessing or using HealthTrail ("the Service"), you agree to be bound by these Terms of Service. 
          If you do not agree to these terms, please do not use our Service.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>2. Description of Service</h2>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)' }}>
          HealthTrail is a fitness and nutrition tracking application that allows users to:
        </p>
        <ul style={{ paddingLeft: '24px', color: 'var(--text-secondary)', lineHeight: '1.8', marginTop: '12px' }}>
          <li>Track food intake and nutritional information</li>
          <li>Log exercise and physical activities</li>
          <li>Use AI-powered food analysis from photos</li>
          <li>Connect wearable devices (Fitbit, Oura Ring)</li>
          <li>Receive personalized fitness coaching</li>
          <li>Set and track health goals</li>
        </ul>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>3. Account Registration</h2>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)' }}>
          To use certain features of the Service, you must register for an account. You agree to:
        </p>
        <ul style={{ paddingLeft: '24px', color: 'var(--text-secondary)', lineHeight: '1.8', marginTop: '12px' }}>
          <li>Provide accurate and complete information during registration</li>
          <li>Maintain the security of your password and account</li>
          <li>Notify us immediately of any unauthorized use of your account</li>
          <li>Accept responsibility for all activities that occur under your account</li>
        </ul>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)', marginTop: '16px' }}>
          New accounts require administrator approval before full access is granted.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>4. User Conduct</h2>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)', marginBottom: '12px' }}>
          You agree not to:
        </p>
        <ul style={{ paddingLeft: '24px', color: 'var(--text-secondary)', lineHeight: '1.8' }}>
          <li>Use the Service for any unlawful purpose</li>
          <li>Upload false, misleading, or inappropriate content</li>
          <li>Attempt to gain unauthorized access to any part of the Service</li>
          <li>Interfere with or disrupt the Service or servers</li>
          <li>Impersonate another person or entity</li>
          <li>Share your account credentials with others</li>
          <li>Use the Service to harass, abuse, or harm others</li>
        </ul>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>5. Health Disclaimer</h2>
        <div style={{ 
          background: '#fef3c7', 
          border: '1px solid #f59e0b', 
          borderRadius: '8px', 
          padding: '20px',
          marginBottom: '16px'
        }}>
          <p className="body-medium" style={{ lineHeight: '1.7', color: '#92400e', fontWeight: 500 }}>
            <strong>Important:</strong> HealthTrail is not a medical service. The information provided through 
            our Service, including AI-generated nutritional analysis and fitness recommendations, is for 
            informational purposes only and should not be considered medical advice.
          </p>
        </div>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)' }}>
          Always consult with a qualified healthcare professional before starting any diet, exercise program, 
          or making changes to your health routine. We are not responsible for any health decisions you make 
          based on information from our Service.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>6. AI-Powered Features</h2>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)' }}>
          Our Service uses artificial intelligence to analyze food images and provide fitness coaching. 
          While we strive for accuracy, AI-generated results may not always be 100% accurate. Nutritional 
          estimates from food photos should be considered approximations. You are encouraged to verify 
          important nutritional information independently.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>7. Third-Party Integrations</h2>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)' }}>
          The Service allows you to connect third-party services such as Fitbit and Oura Ring. Your use of 
          these integrations is subject to the terms and privacy policies of those third parties. We are not 
          responsible for the practices of third-party services.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>8. Intellectual Property</h2>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)' }}>
          The Service and its original content, features, and functionality are owned by HealthTrail and are 
          protected by international copyright, trademark, and other intellectual property laws. You may not 
          copy, modify, distribute, or create derivative works based on the Service without our express 
          written permission.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>9. User Content</h2>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)' }}>
          You retain ownership of any content you submit to the Service (such as food photos and messages). 
          By submitting content, you grant us a non-exclusive, worldwide, royalty-free license to use, store, 
          and process that content for the purpose of providing and improving the Service.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>10. Termination</h2>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)' }}>
          We reserve the right to terminate or suspend your account and access to the Service at our sole 
          discretion, without notice, for conduct that we believe violates these Terms or is harmful to other 
          users, us, or third parties, or for any other reason.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>11. Limitation of Liability</h2>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)' }}>
          To the maximum extent permitted by law, HealthTrail shall not be liable for any indirect, incidental, 
          special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred 
          directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting 
          from your use of the Service.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>12. Disclaimer of Warranties</h2>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)' }}>
          The Service is provided "as is" and "as available" without warranties of any kind, either express 
          or implied, including but not limited to implied warranties of merchantability, fitness for a 
          particular purpose, and non-infringement.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>13. Changes to Terms</h2>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)' }}>
          We reserve the right to modify these Terms at any time. We will notify users of any material changes 
          by posting the new Terms on this page. Your continued use of the Service after changes are posted 
          constitutes your acceptance of the modified Terms.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>14. Governing Law</h2>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)' }}>
          These Terms shall be governed by and construed in accordance with applicable laws, without regard 
          to conflict of law principles.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 className="heading-4" style={{ marginBottom: '16px' }}>15. Contact Us</h2>
        <p className="body-medium" style={{ lineHeight: '1.7', color: 'var(--text-secondary)' }}>
          If you have any questions about these Terms of Service, please contact us through the app's 
          messaging system or reach out to an administrator.
        </p>
      </section>
    </div>
  );
}

export default TermsOfService;
